// Fendas de Noxara (dungeons): instância de 3 câmaras e o Guardião da Fenda, sozinho ou com a party.
// O tier vem do level (um tier a cada 50 levels, como os desafios do design); os monstros são os das hunts daquele tier.
// Sem respawn; 20 minutos para terminar. Recompensa: gold do tier, um equipamento do tier com raridade de boss (no mínimo Raro)
// e fragmentos de pedra de proteção. 3 entradas por dia (VIP 4). Valores propostos.
export const RIFT_TIME_MS = 20 * 60_000;
export const RIFT_ENTRIES = { free: 3, vip: 4 } as const;
export const riftTier = (level: number) => Math.max(1, Math.floor(level / 50) + 1);
/** faixa de level das hunts que fornecem os monstros do tier */
export const riftLevels = (tier: number): [number, number] => [Math.max(1, (tier - 1) * 50 - 20), tier * 50 + 30];
export const riftGold = (tier: number) => 15_000 * tier;
export const RIFT_HP_MULT = 1.6, RIFT_DMG_MULT = 1.3;
